import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

export interface Breadcrumb {
  label: string;
  url: string;
}

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  standalone: false,
})
export class BreadcrumbComponent implements OnInit {
  breadcrumbs: Breadcrumb[] = [];

  private destroyRef = inject(DestroyRef);

  constructor(private router: Router) {}

  navigate(url: string): void {
    this.router.navigateByUrl(url);
  }

  ngOnInit(): void {
    this.breadcrumbs = this.build(this.router.routerState.snapshot.root);

    this.router.events
      .pipe(
        filter((e) => e instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => {
        this.breadcrumbs = this.build(this.router.routerState.snapshot.root);
      });
  }

  private build(
    route: ActivatedRouteSnapshot,
    url = '',
    crumbs: Breadcrumb[] = [],
  ): Breadcrumb[] {
    const routeUrl = route.url.length
      ? url + '/' + route.url.map((s) => s.path).join('/')
      : url;

    if (route.data['title'] && routeUrl) {
      if (!crumbs.find((c) => c.url === routeUrl)) {
        crumbs.push({ label: route.data['title'], url: routeUrl });
      }
    }

    if (route.firstChild) {
      this.build(route.firstChild, routeUrl, crumbs);
    }

    return crumbs;
  }
}
